<!--
 * @Author: 黄露
 * @LastEditors: 黄露
 * @description:  van-action-sheet 组件二次封装
 * @Date: 2021-09-14 14:36:56
 * @LastEditTime: 2021-11-23 16:29:21
-->

<template>
  <div class="action-sheet">
    <van-cell is-link :title="config.title" value-class="flex align-center justify-end" @click="openActionSheet">
      <template #value>
        <span class="store-name ml-10">{{ modelValue.name }}</span>
      </template>
    </van-cell>
    <van-action-sheet v-model:show="show" :actions="countryList" :title="config.actionSheetTitle" @select="onSelect" />
  </div>
</template>

<script setup>
import {defineProps,toRefs,ref,defineEmits,computed} from "vue"
import { languageForRegion } from 'model/common.js'
// props
const props = defineProps({
  modelValue:{
    type:Object,
    default:()=>{}
  },
  region: {
    type: String,
    default: ''
  },
  config:{
    type:Object,
    default:()=>{
      return {
        title:'title',
        actionSheetTitle:'actionSheetTitle'
      }
    },

  }
})
const emit = defineEmits(['update:modelValue','onSelcet'])
const {config,region} = toRefs(props)
const show = ref(false)

const openActionSheet = ()=>{
  show.value = !show.value
}

const countryList = computed(()=>{
  return languageForRegion(region.value).map(item=>({name:item.label,...item}))
})

emit('update:modelValue',countryList.value[0])

const onSelect = (item)=>{
  show.value = false
  emit('update:modelValue',item)
  emit('onSelcet',item)
}



</script>
<style lang="scss" scoped>

.store-name {
  font-size: $fontText;
  color: $fontColor;
}

.action-sheet {
  &:deep(.van-cell__title, .van-cell__value) {
    flex: auto;
  }

  &:deep(.van-action-sheet__header) {
    font-weight: bold;
    margin: 0 10px;
    border-bottom: 1px solid $border;
  }

  &:deep(.van-action-sheet__content) {
    padding: 0 10px;
    margin-bottom: 30px;
  }

  &:deep(.van-cell__title) {
    font-weight: bold;
    color: $fontColor;
  }

  &:deep(.van-cell__value) {
    overflow: unset;
    white-space: nowrap;
    font-size: $fontText;
  }

  &:deep(.van-tab__text--ellipsis) {
    line-clamp: initial;
    -webkit-line-clamp: initial;
  }

  &:deep(.van-action-sheet) {
    z-index: 10003 !important;
  }
}

</style>